module.exports = __webpack_public_path__ + "img/zip.331ac354.svg";